import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectComponentsRedirectRoute: InvariantJiraRoute = {
	name: 'project-components-redirect',
	path: '/projects/:projectKey',
	query: ['selectedItem=com.atlassian.jira.jira-projects-plugin:components-page'],
};
